import React from 'react';
import { IIconProps } from '../interfaces';
const UserIcon = (props: IIconProps) => {

  return (
      <svg width={ props.width } height={ props.height } viewBox="0 0 18 20" xmlns="http://www.w3.org/2000/svg"><path d="M9 12c4.169 0 9 1.935 9 5v2a1 1 0 0 1-2 0v-2c0-1.46-3.844-3-7-3l-.232.003C5.658 14.075 2 15.576 2 17v2a1 1 0 0 1-2 0v-2c0-3.065 4.831-5 9-5zM9 0c2.762 0 5 2.238 5 5s-2.238 5-5 5-5-2.238-5-5 2.238-5 5-5zm0 2C7.342 2 6 3.342 6 5s1.342 3 3 3 3-1.342 3-3-1.342-3-3-3z" fill={ props.color } /></svg>
  )
};

export default UserIcon;